<template>
  <div>
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="warehouseOrder">
      <el-form ref="orderForm" :model="orderForm">
        <div class="wrap">
          <div class="main">
            <main class="main__content">
              <div class="step__sections" v-if="!submmited">
                <div class="section section--shipping-address">
                  <!-- customer information start-->
                  <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                    <div class="title">
                      <span>{{ $t("createOutboundInv") }}</span>
                    </div>
                    <div class="fieldset">
                      <el-row :gutter="20">
                        <!-- <el-col :span="8">
                          <button class="btn" @click="goToOther">
                            <span>{{ $t("upsFedex") }}</span>
                          </button>
                        </el-col> -->
                        <el-col :span="8">
                          <button class="btn" @click="goToXPO">
                            <span>{{ $t("ltl") }}</span>
                          </button>
                        </el-col>
                        <el-col :span="8">
                          <button class="btn" @click="goToImport">
                            <span>{{ $t("importmso") }}</span>
                          </button>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
              
              </div>
            </main>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {Alert} from "element-ui";
  import axios from "axios";
  import breadcrumb from "../../components/breadcrumb";
  import logo from "../../assets/img/logo.png";

  export default {
    name: "outboundInv",
    components: {
      breadcrumb,
    },
    data() {
      return {
        path2: this.$t("header2"),
      };
    },
    methods: {
      goToOther() {
        this.$router.push({name: 'upsFedex'});
      },
      goToXPO() {
        this.$router.push({name: 'outboundXPO'});
      },
      goToImport() {
        this.$router.push({name: 'mso'});
      },
    },
    mounted() {
      this.$store.dispatch('orders/fetchInboundProducts');
      this.$store.dispatch("addresses/fetchAddresses");
      this.$store.dispatch("addresses/fetchWarehouseAddresses");
    },
  };
</script>

<style lang="less">
  @import "../../assets/css/warehouseOrder.less";
</style>



// WEBPACK FOOTER //
// src/view/Service/outboundInv.vue